import * as modelDefinitions from './modelDefinitions'
import QuickFiltersMixin from '@/common/quickFilters'

export default {
  computed: {
    modelsSetup() {
      const models = {}
      for (const fileName of Object.keys(modelDefinitions)) {
        // Multiple Models per file support
        for (const modelInFile of Object.keys(modelDefinitions[fileName].computed)) {
          models[modelInFile] = this[modelInFile]
        }
      }
      return models
    }
  },
  mixins: [...Object.values(modelDefinitions), QuickFiltersMixin],
  mounted() {
    console.log(modelDefinitions)
    this.setModels()
    this.$root.$on('reloadModels', () => this.setModels())
  },
  methods: {
    setModels() {
      console.log(this.modelsSetup)
      this.$store.dispatch('setModels', this.modelsSetup)
    }
  }
}
